export interface OrderPageType {
    id: string;
    createdAt: string;
    updatedAt: string | null;
    deletedAt: string | null;
    name: string;
    description: string | null;

    customer: boolean;
    assignedTo: boolean;
    registrationNumber: boolean;
    vin: boolean;
    carInfo: boolean;
    aoNumber: boolean;
    externalOrderId: boolean;
    foNumber: boolean;
    ioNumber: boolean;
    orderType: boolean;
    orderedBy: boolean;
    followUp: boolean;
    emailBody: boolean;
    warehouseLocation: boolean;
    supplier: boolean;
    arriveDate: boolean;
    bookingDate: boolean;
    deliveryDate: boolean;
    pickupTime: boolean;
    orderDate: boolean;
    fileName: boolean;
    comment: boolean;
    internalComment: boolean;
    carUrl: boolean;
    emailPriceProposal: boolean;
    emailVerification: boolean;

    articleTableQuantity: boolean;
    articleTableDescription: boolean;
    articleTableArticleNumber: boolean;
    articleTablePurchasePrice: boolean;
    articleTableSalesPrice: boolean;
    articleTableSupplierName: boolean;
    articleTableIONumber: boolean;
    articleTableComment: boolean;
    articleTableDiscount: boolean;
    articleTablePartUrl: boolean;
    articleTableIsSyncedWithAX: boolean;
}

export const defaultOrderPageType: OrderPageType = {
    id: "",
    createdAt: "",
    updatedAt: null,
    deletedAt: null,
    name: "",
    description: null,
    customer: true,
    assignedTo: true,
    registrationNumber: true,
    vin: true,
    carInfo: true,
    aoNumber: true,
    externalOrderId: true,
    foNumber: true,
    ioNumber: true,
    orderType: true,
    orderedBy: true,
    followUp: true,
    emailBody: true,
    warehouseLocation: true,
    supplier: true,
    arriveDate: true,
    bookingDate: true,
    deliveryDate: true,
    pickupTime: true,
    orderDate: true,
    fileName: true,
    comment: true,
    internalComment: true,
    carUrl: true,
    emailPriceProposal: false,
    emailVerification: false,

    articleTableQuantity: true,
    articleTableDescription: true,
    articleTableArticleNumber: true,
    articleTablePurchasePrice: true,
    articleTableSalesPrice: true,
    articleTableSupplierName: true,
    articleTableIONumber: true,
    articleTableComment: true,
    articleTableDiscount: true,
    articleTablePartUrl: true,
    articleTableIsSyncedWithAX: true,
}